import { $ } from './util';
import * as Comments from './comments';

Comments.Credentials.setup();
Comments.Quoter.setup();
Comments.Highlighter.setup('comment_preview');
Comments.Validator.setup();

if ( $('comment_form') ) {
  // eslint-disable-next-line
  let previewer = new Comments.Previewer('comment_preview', 'comment_form');
}
